var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: { name: "bookings.show", params: { id: _vm.booking.id } },
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v(_vm._s(_vm.booking.name))]
        },
        proxy: true,
      },
      {
        key: "meta",
        fn: function () {
          return [
            _c("meta-item", { attrs: { "is-name": true, icon: "user" } }, [
              _vm._v(
                "\n      " + _vm._s(_vm.bookingAttendingTalentNames) + "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "hero",
        fn: function () {
          return [_vm._v("View")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }